var _linearGradient, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 92,
    viewBox: "0 0 92 92",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sign-mls",
    gradientUnits: "userSpaceOnUse",
    x1: 46,
    x2: 46,
    y1: 0,
    y2: 92
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#sign-mls)",
    height: 92,
    rx: 28,
    width: 92
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.8018 40.2354h15.1313c1.8555 0 2.7925-.9371 2.7925-2.7647v-10.7061c0-1.8276-.937-2.7646-2.7925-2.7646h-15.1313c-1.8555 0-2.8018.9277-2.8018 2.7646v10.7061c0 1.8369.9463 2.7647 2.8018 2.7647zm-1.2803-13.378c0-.8906.4731-1.3452 1.3266-1.3452h15.0386c.8443 0 1.3267.4546 1.3267 1.3452v2.1524h-17.6919zm14.6489 1.5122c.603-.0092 1.104-.5102 1.104-1.104 0-.603-.501-1.1133-1.104-1.1133-.5937 0-1.104.5103-1.104 1.1133 0 .5938.5103 1.1226 1.104 1.104zm-14.6489 5.4922v-3.4883h17.6919v3.4883zm14.6489-.6587c.603-.0093 1.104-.501 1.104-1.104s-.501-1.1133-1.104-1.1133c-.5937 0-1.104.5103-1.104 1.1133s.5103 1.1226 1.104 1.104zm-13.3223 5.5108c-.8535 0-1.3266-.4546-1.3266-1.3452v-2.1338h17.6919v2.1338c0 .8906-.4824 1.3452-1.3267 1.3452zm13.3223-.668c.603-.0186 1.104-.5103 1.104-1.1133s-.501-1.1133-1.104-1.1133c-.5937 0-1.104.5103-1.104 1.1133s.5103 1.1226 1.104 1.1133z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.988 62h-1.989v-8.415l-3.485 8.415h-.85l-3.468-8.415v8.415h-1.989v-11.339h2.805l3.077 7.463 3.094-7.463h2.805zm9.4003 0h-6.987v-11.339h1.989v9.588h4.998zm5.6713.204c-1.9494 0-3.485-.6007-4.607-1.802l1.105-1.53c.9746 1.0427 2.1703 1.564 3.587 1.564.7593 0 1.326-.153 1.7-.459.3853-.306.578-.6687.578-1.088 0-.4307-.2267-.7707-.68-1.02-.4534-.2607-1.003-.4647-1.649-.612s-1.2977-.323-1.955-.527c-.646-.204-1.1957-.5497-1.649-1.037-.4534-.4873-.68-1.1163-.68-1.887 0-.952.3796-1.7397 1.139-2.363.7706-.6347 1.768-.952 2.992-.952 1.7453 0 3.162.527 4.25 1.581l-1.139 1.479c-.8614-.8613-1.955-1.292-3.281-1.292-.5894 0-1.0597.1303-1.411.391-.34.2493-.51.5893-.51 1.02 0 .2833.119.5213.357.714.2493.1927.5666.3513.952.476.3853.1133.8103.2267 1.275.34.476.1133.9463.255 1.411.425.476.1587.9066.357 1.292.595.3853.238.697.5667.935.986.2493.4193.374.918.374 1.496 0 1.02-.3684 1.8587-1.105 2.516-.7367.6573-1.8304.986-3.281.986z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMls);
export default __webpack_public_path__ + "static/media/mls.9efa4958.svg";
export { ForwardRef as ReactComponent };